export function hasMultipleActiveSessions(userSession) {
    const currentTime = new Date();
    const currentSessionId = userSession?.CurrentSession?.Id;
    const hasMultipleActive = userSession?.LoginAttempts?.some((la) => la != null &&
        la.Id !== currentSessionId &&
        !hasExpired(la, currentTime));
    return hasMultipleActive;
}
export const hasExpired = (la, now) => la.Expires == null || new Date(la.Expires) < now || la.IsDeleted === true;
